import type { ApprovalChain } from '../approval-chain.model';

export const LAND_TENURE_TRANSFER_BOND_CHAIN: ApprovalChain = {
  id: 'land-tenure-transfer-bond',
  label: 'Land Tenure Transfer with Bond',
  applicationTypes: ['LAND_TENURE_TRANSFER_BOND'],
  steps: [
    {
      role: 'FIRST_BANK_USER',
      action: 'Recommend',
      from: ['LOCAL_GOVERNMENT_APPROVED', 'RESUBMITTED', 'SUBMITTED', 'PENDING', 'MINISTRY_OF_LANDS_DIRECTOR_LEGAL_APPROVED'],
      to: 'FIRST_BANK_USER_APPROVED',
    },
    { role: 'FINANCE_OFFICER', action: 'Approve Payment', from: ['FIRST_BANK_USER_APPROVED', 'SUBMITTED', 'RESUBMITTED'], to: 'FINANCE_APPROVED' },
    { role: 'EXAMINER', action: 'Recommend', from: ['FINANCE_APPROVED'], to: 'EXAMINER_RECOMMENDED' },
    { role: 'REGISTRAR', action: 'Verify', from: ['EXAMINER_RECOMMENDED'], to: 'REGISTRAR_VERIFIED' },
  ],
};
